import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'itc-form-errors',
  templateUrl: './form-errors.component.html',
  styleUrls: ['./form-errors.component.scss'],
  imports: [CommonModule]
})
export class FormErrorsComponent implements OnInit {
  @Input() erroredFields: any[];
  constructor() {}

  @Output() focusElementClicked = new EventEmitter<any>();
  ngOnInit(): void {}

  formatErrorKey(key: PropertyKey): string {
    return `-${String(key)}`;
  }

  focusElement(field: any) {}
}
